import { memo, useMemo, CSSProperties } from 'react';
import { ResourceColumnRow } from './ResourceColumnRow';
import { ColumnRowProps } from '../../ColumnRowProps';
import { ROW_HEIGHT, COLUMN_WIDTH, BORDER, ROW_EXPANDED_HEIGHT } from '../../../../CONSTANTS';

export const ResourceColumnContainer = memo(function ResourceColumnContainer({
    columnIndex,
    columnRow,
    rowId,
    isAdminProject,
    start,
	expanded
}: ColumnRowProps & { start: number, expanded: boolean  }) {
    const style = useMemo(() => {
        return {
            width: `${COLUMN_WIDTH}px`,
            position: 'absolute',
            transform: `translateX(${start}px)`,
            top: 0,
            left: 0,
			height: `${expanded ? ROW_EXPANDED_HEIGHT : ROW_HEIGHT}px`,
            boxSizing: 'border-box',
            borderBottom: BORDER,
            borderRight: BORDER,
        } as CSSProperties;
    }, [expanded, start]);
    return (
        <div style={style}>
            <ResourceColumnRow columnRow={columnRow} columnIndex={columnIndex} rowId={rowId} isAdminProject={isAdminProject} expanded={expanded} />
        </div>
    );
});
